module.exports = __webpack_public_path__ + "static/media/06.661135f3.webp";